namespace $ {

	/**
	 * Checks for E-Mail and returns string type.
	 * @see https://mol.hyoo.ru/#!section=demos/demo=mol_data_email_demo
	 */
	export let $mol_data_email = $mol_data_pattern( /.+@.+/ )
	
}
